import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../redux";
import { ModalContext } from "../../../../Common/Modal";

const ModalHeader = () => {
  const { typography } = useTheme();
  const { headerRef } = useContext(ModalContext);
  const { active_post_id } = useAppSelector((state) => state.postAnalysis);
  return (
    <Container ref={headerRef}>
      <Components.Text
        style={{ tokenStyle: typography.Heading.M }}
        text="Post Analysis"
        lineHeight="line-height-750"
        fontWeight="font-weight-semibold"
      />
      <Components.Label
        color="Primary"
        kind="Fill"
        text={`Post ID: ${active_post_id}`}
      />
    </Container>
  );
};

export default ModalHeader;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-9"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
